import {createI18n, I18nOptions, LocaleMessages, VueMessageType,} from "vue-i18n";
import localeMessagesEn from "@/locales/en.json"
import localeMessagesEnPH from "@/locales/en-PH.json"
import localeMessagesES from "@/locales/es.json"
import localeMessagesEsCO from "@/locales/es-CO.json"
import localeMessagesEsMX from "@/locales/es-MX.json"
import localeMessagesFil from "@/locales/fil.json"
import localeMessagesCebPH from "@/locales/ceb-PH.json"
import localeMessagesFilPH from "@/locales/fil-PH.json"
import localeMessagesTlPH from "@/locales/tl-PH.json"

function loadLocaleMessages(): { [x: string]: LocaleMessages<VueMessageType> } {
    /*
     * Values taken from src/locales.
     * Not as clean as the previous method, but it is more explicit and we do not need to mock require.context from webpack in order to run the tests using jest.
     * LOCALES NEED TO BE ADDED MANUALLY BY IMPORTING THE JSON AND THEN ADDING IT AS A KEY TO THE MESSAGES VARIABLE
     */
    const messages: { [x: string]: LocaleMessages<VueMessageType> } = {};
    messages["en"] = localeMessagesEn
    messages["en-PH"] = localeMessagesEnPH
    messages["es"] = localeMessagesES
    messages["es-CO"] = localeMessagesEsCO
    messages["es-MX"] = localeMessagesEsMX
    messages["fil"] = localeMessagesFil
    messages["ceb-PH"] = localeMessagesCebPH
    messages["fil-PH"] = localeMessagesFilPH
    messages["tl-PH"] = localeMessagesTlPH
    return messages;
}

function getFallbackLocale(locale: string) {
    let fallbackLocale = "en-US"

    if (locale.includes("es")) {
        fallbackLocale = "es-MX"
    }

    const philippinesDiscriminators = ["PH", "fil", "tgl", "tl", "ceb"]

    philippinesDiscriminators.forEach((discriminator) => {
        if (locale.includes(discriminator)) {
            fallbackLocale = "fil-PH"
        }
    })

    return fallbackLocale
}

const i18nOptions: I18nOptions = {
    legacy: false,
    locale: window.navigator.language || "es-MX",
    fallbackLocale: getFallbackLocale(window.navigator.language),
    messages: loadLocaleMessages(),
    globalInjection: true,
    numberFormats: {
        "en-US": {
            currency: {
                style: "currency",
                currency: "USD",
                notation: "standard",
                minimumFractionDigits: 0,
            },
            decimal: {
                style: "decimal",
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
            },
            percent: {
                style: "percent",
                useGrouping: false,
            },
        },
        // ************************************************************ COLOMBIA
        "es-CO": {
            currency: {
                style: "currency",
                currency: "COP",
                useGrouping: true,
                currencyDisplay: "symbol",
                minimumFractionDigits: 0,
            },
            decimal: {
                style: "decimal",
                minimumSignificantDigits: 0,
                maximumSignificantDigits: 2,
            },
            percent: {
                style: "percent",
                useGrouping: false,
            },
        },
        // ************************************************************ MEXICO
        "es-MX": {
            currency: {
                style: "currency",
                currency: "MXN",
                useGrouping: true,
                currencyDisplay: "symbol",
                minimumFractionDigits: 0,
            },
            decimal: {
                style: "decimal",
                minimumSignificantDigits: 0,
                maximumSignificantDigits: 2,
            },
            percent: {
                style: "percent",
                useGrouping: false,
            },
        },
        // ************************************************************ PHILIPPINES
        "fil-PH": {
            currency: {
                style: "currency",
                currency: "PHP",
                useGrouping: true,
                currencyDisplay: "symbol",
                minimumFractionDigits: 2,
            },
            decimal: {
                style: "decimal",
                minimumSignificantDigits: 0,
                maximumSignificantDigits: 2,
            },
            percent: {
                style: "percent",
                useGrouping: false,
            },
        },
        "fil": {
            currency: {
                style: "currency",
                currency: "PHP",
                useGrouping: true,
                currencyDisplay: "symbol",
                minimumFractionDigits: 2,
            },
            decimal: {
                style: "decimal",
                minimumSignificantDigits: 0,
                maximumSignificantDigits: 2,
            },
            percent: {
                style: "percent",
                useGrouping: false,
            },
        },
        "en-PH": {
            currency: {
                style: "currency",
                currency: "PHP",
                useGrouping: true,
                currencyDisplay: "symbol",
                minimumFractionDigits: 2,
            },
            decimal: {
                style: "decimal",
                minimumSignificantDigits: 0,
                maximumSignificantDigits: 2,
            },
            percent: {
                style: "percent",
                useGrouping: false,
            },
        },
        "tl-PH": {
            currency: {
                style: "currency",
                currency: "PHP",
                useGrouping: true,
                currencyDisplay: "symbol",
                minimumFractionDigits: 2,
            },
            decimal: {
                style: "decimal",
                minimumSignificantDigits: 0,
                maximumSignificantDigits: 2,
            },
            percent: {
                style: "percent",
                useGrouping: false,
            },
        },
        "ceb-PH": {
            currency: {
                style: "currency",
                currency: "PHP",
                useGrouping: true,
                currencyDisplay: "symbol",
                minimumFractionDigits: 2,
            },
            decimal: {
                style: "decimal",
                minimumSignificantDigits: 0,
                maximumSignificantDigits: 2,
            },
            percent: {
                style: "percent",
                useGrouping: false,
            },
        },
    },
    datetimeFormats: {
        "en-US": {
            short: {
                year: "numeric",
                month: "short",
                day: "numeric",
            },
            medium: {
                weekday: "short",
                day: "numeric",
                month: "short"
            },
            long: {
                // year: "numeric",
                month: "short",
                day: "numeric",
                weekday: "short",
                hour: "numeric",
                minute: "numeric",
            },
        },
        // ************************************************************ COLOMBIA
        "es-CO": {
            short: {
                year: "numeric",
                month: "short",
                day: "numeric",
            },
            medium: {
                weekday: "short",
                day: "numeric",
                month: "short"
            },
            long: {
                year: "numeric",
                month: "short",
                day: "numeric",
                weekday: "short",
                hour: "numeric",
                minute: "numeric",
            },
        },
        // ************************************************************ MEXICO
        "es-MX": {
            short: {
                year: "numeric",
                month: "short",
                day: "numeric",
            },
            medium: {
                weekday: "short",
                day: "numeric",
                month: "short"
            },
            long: {
                year: "numeric",
                month: "short",
                day: "numeric",
                weekday: "short",
                hour: "numeric",
                minute: "numeric",
            },
        },
        // ************************************************************ PHILIPPINES
        "fil-PH": {
            short: {
                year: "numeric",
                month: "short",
                day: "numeric",
            },
            medium: {
                weekday: "short",
                day: "numeric",
                month: "short"
            },
            long: {
                year: "numeric",
                month: "short",
                day: "numeric",
                weekday: "short",
                hour: "numeric",
                minute: "numeric",
            },
        },
        "fil": {
            short: {
                year: "numeric",
                month: "short",
                day: "numeric",
            },
            medium: {
                weekday: "short",
                day: "numeric",
                month: "short"
            },
            long: {
                year: "numeric",
                month: "short",
                day: "numeric",
                weekday: "short",
                hour: "numeric",
                minute: "numeric",
            },
        },
        "en-PH": {
            short: {
                year: "numeric",
                month: "short",
                day: "numeric",
            },
            medium: {
                weekday: "short",
                day: "numeric",
                month: "short"
            },
            long: {
                year: "numeric",
                month: "short",
                day: "numeric",
                weekday: "short",
                hour: "numeric",
                minute: "numeric",
            },
        },
        "tl-PH": {
            short: {
                year: "numeric",
                month: "short",
                day: "numeric",
            },
            medium: {
                weekday: "short",
                day: "numeric",
                month: "short"
            },
            long: {
                year: "numeric",
                month: "short",
                day: "numeric",
                weekday: "short",
                hour: "numeric",
                minute: "numeric",
            },
        },
        "ceb-PH": {
            short: {
                year: "numeric",
                month: "short",
                day: "numeric",
            },
            medium: {
                weekday: "short",
                day: "numeric",
                month: "short"
            },
            long: {
                year: "numeric",
                month: "short",
                day: "numeric",
                weekday: "short",
                hour: "numeric",
                minute: "numeric",
            },
        },
    }
};

const i18n = createI18n(i18nOptions);

function updateCurrencySymbol(locale: string, numberFormats: any, country: string) {
    if (numberFormats[locale]) {
        switch (country) {
            case 'CO': {
                numberFormats[locale].currency.currency = 'COP';
                numberFormats[locale].currency.style = "currency";
                numberFormats[locale].currency.useGrouping = true;
                numberFormats[locale].currency.currencyDisplay = "symbol";
                numberFormats[locale].currency.minimumFractionDigits = 2;
                break;
            }
            case 'MX': {
                numberFormats[locale].currency.currency = 'MXN';
                numberFormats[locale].currency.style = "currency";
                numberFormats[locale].currency.useGrouping = true;
                numberFormats[locale].currency.currencyDisplay = "symbol";
                numberFormats[locale].currency.minimumFractionDigits = 2;
                break;
            }
            case 'PH': {
                numberFormats[locale].currency.currency = 'PHP';
                numberFormats[locale].currency.style = "currency";
                numberFormats[locale].currency.useGrouping = true;
                numberFormats[locale].currency.currencyDisplay = "symbol";
                numberFormats[locale].currency.minimumFractionDigits = 2;
                break;
            }
        }
    }
}

export {updateCurrencySymbol, getFallbackLocale};
export default i18n;
